import 'primeflex/primeflex.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './_layout/layout.scss';
import './_layout/app.scss';
import './css/App.css';
import './css/AppResponsivo.css';

import { useEffect, useState, useMemo, useContext, useRef} from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate, useNavigate} from 'react-router-dom';

import classNames from 'classnames';
import PrimeReact from 'primereact/api';
import { ProgressBar } from 'primereact/progressbar';
import { AppTopbar } from './_template/AppTopbar';
import { AppTopbarLogo } from './_template/AppTopbarLogo';
import { CSSTransition } from 'react-transition-group';
import { AppMenu } from './_template/AppMenu';
import { ScrollToTop } from './_template/ScrollToTop';

//Contextos da aplicação
import AppContext from './hooks/AppContext'
import SearchParamContext from './hooks/SearchParamContext'
import RouteContext from './hooks/RouteContext'
import InstanciaParam from "./hooks/InstanciaParam"
import ProtectedRoute from './hooks/ProtectedRoute'
  
//componentes app
import Secoes from './pages/Secoes';
import Acompanhamento from './pages/Acompanhamento';
import AcompanhamentoMapa from './pages/AcompanhamentoMapa';
import Votacao from './pages/Votacao';
import Pendencias from './pages/Pendencias';
import Login from './pages/Login';
import ErrorPage from './_template/ErrorPage';

//utils 
import PATH from "./utils/Paths"
import { getMenu } from './utils/menu'

import qrIMG from './assets/images/v1.png'

const App = (props) => {

  const { loading, user, logout, instancia, instanciaInfo, tema, 
    rolagemAuto, setRolagemAuto, rolagemAutoIntervalo, setRolagemAutoIntervalo,
    ordenaPorVoto, setOrdenaPorVoto, 
    ocultaLidas, setOcultaLidas, ocultaNLidas, setOcultaNLidas, 
    ocultaZonasConcluidas, setOcultaZonasConcluidas} = useContext(AppContext);

  const { searchParams } = useContext(SearchParamContext);
  const { routeName, rotaVotacao, rotaSecoes, rotaAcompanhamento, rotaPendencias, rotaLogin, rotaError} = useContext(RouteContext);

  PrimeReact.ripple = true;

  const [sidebarActive, setSidebarActive] = useState(false);
  const sidebar = useRef()

  //Navegacao
  const navigate = useNavigate();

  const menu = useMemo( ()=> getMenu(user),[user])

  //nome sistema com fase
  const nomeSistemaComFase = useMemo(
    () => {
      let nome = props.nomeSistema;
      if(instanciaInfo?.fase && instanciaInfo?.fase!=="oficial"){        
        nome = nome + " - " + "Treinamento"        
      }
      return nome
    },      
    [instanciaInfo]
  );

  const infoSistema = useMemo(
    () => {
      let sufixo = " - v" + props.versao + " - "+ props.data || ""
      if(instancia){
        return props.nomeSistema + " - " + instancia || "instancia" + sufixo
      }      
      return props.nomeSistema + sufixo
    },      
    [instancia,instanciaInfo]
  );
  

  const onToggleMenu = (event) => {
    setSidebarActive((prevState) => !prevState);
    event.preventDefault();
  }

  const onMenuItemClick = (event) => {
    setSidebarActive(false);
  }

  const goHome = () => {       
    navigate({         
      pathname: PATH.VOTACAO+"/"+instancia,
      replace: true, 
      search: searchParams.toLocaleString()
    })
  }  

  return (    
      <ScrollToTop>
     
        {loading && 
          <div className="app-loader">
            <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
          </div>
        }
          
        <div className="layout-wrapper layout-static">
          
          <AppTopbar theme={tema} onToggleMenu={onToggleMenu} 
            menu={menu} sidebarIsVisible={sidebarActive} goHome={() => goHome()}
            perfil={user} perfilNome={user?.email} logout={logout}
            nomeSistema={nomeSistemaComFase} 
            nomeCompletoSistema={props.nomeSistema || "QRTot" }
            info={infoSistema}
            config
            rolagemAuto={rolagemAuto}
            setRolagemAuto={setRolagemAuto}
            rolagemAutoIntervalo={rolagemAutoIntervalo}
            setRolagemAutoIntervalo={setRolagemAutoIntervalo}
            ordenaPorVoto={ordenaPorVoto}
            setOrdenaPorVoto={setOrdenaPorVoto}
            ocultaLidas={ocultaLidas}
            setOcultaLidas={setOcultaLidas}
            ocultaNLidas={ocultaNLidas}
            setOcultaNLidas={setOcultaNLidas}
            ocultaZonasConcluidas={ocultaZonasConcluidas}
            setOcultaZonasConcluidas={setOcultaZonasConcluidas}
            >
          </AppTopbar>
          <CSSTransition classNames="layout-sidebar" timeout={{ enter: 200, exit: 200 }} in={sidebarActive} unmountOnExit>
              <div ref={sidebar} className="layout-sidebar layout-sidebar-light">
                <AppTopbarLogo nomeSistema={nomeSistemaComFase} class="p-grid p-justify-center container-logo logo-topbar w-full"/>                                
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} instancia={instancia}/>
              </div>
          </CSSTransition>
            
          <div className="app-layout flex flex-column">
            <Routes>

              <Route exact path={PATH.LOGIN}>
                <Route exact path="" element={                  
                  <Login/>
                }/>
                <Route exact path=":urlInstancia" element={                                   
                  <Login/>
                }/>
              </Route>   

              <Route exact path={PATH.VOTACAO}>
                <Route exact path="" element={
                  <InstanciaParam>
                    <Votacao/>
                  </InstanciaParam>
                }/> 
                <Route exact path=":urlInstancia" element={
                  <InstanciaParam>
                    <Votacao/>
                  </InstanciaParam>
                }/> 
              </Route>
              
              <Route exact path={PATH.ACOMPANHAMENTO}>
                <Route exact path="" element={
                  <InstanciaParam>
                    <Acompanhamento/> 
                  </InstanciaParam>
                }/>
                <Route exact path=":urlInstancia" element={
                  <InstanciaParam>
                    <Acompanhamento/> 
                  </InstanciaParam>
                }/>                  
              </Route>                

              <Route exact path={PATH.MAPA}>
                <Route exact path="" element={
                  <InstanciaParam>
                    <AcompanhamentoMapa/> 
                  </InstanciaParam>
                }/>
                <Route exact path=":urlInstancia" element={
                  <InstanciaParam>
                    <AcompanhamentoMapa/> 
                  </InstanciaParam>
                }/>                             
              </Route>

              <Route exact path={PATH.SECOES}>
                <Route exact path="" element={
                  <InstanciaParam>
                    <Secoes/> 
                  </InstanciaParam>
                }/>
                <Route exact path=":urlInstancia" element={
                  <InstanciaParam>
                    <Secoes/> 
                  </InstanciaParam>
                }/>
              </Route>                

              <Route exact path={PATH.PENDENCIAS}>
                <Route exact path="" element={ 
                  <ProtectedRoute>
                    <InstanciaParam>
                      <Pendencias/>
                    </InstanciaParam>
                  </ProtectedRoute>
                }/>
                <Route exact path=":urlInstancia" element={
                  <ProtectedRoute>
                    <InstanciaParam>
                      <Pendencias/>
                    </InstanciaParam>
                  </ProtectedRoute>
                }/>
              </Route>
            
              <Route exact path="/">
                <Route exact path="" element={
                  <Navigate to={PATH.VOTACAO}/>
                }/>
              </Route>

              <Route path={PATH.ERROR500} element={<ErrorPage codigo="500" mensagem="Erro interno da aplicação" />} />            
              <Route path="*" element={<ErrorPage codigo="404" mensagem="Página Não encontrada" />} />
            </Routes>

            {!rotaLogin &&  
              <div className="app-info flex-column" >
                <div className="w-full font-bold">
                  A Solução QRTot tem caráter experimental e é uma conferência adicional (Resolução TRE-SC n. 8054/2022).
                </div>
                <div className="w-full">
                  As informações representam o somatório dos dados contidos no QR Code dos Boletins de Urna, desconsideradas situações judiciais. Para fins de resultado da Eleição, consulte a divulgação oficial da Justiça Eleitoral.
                </div>
              </div>
            }
            {!loading && 
              <a href="https://play.google.com/store/apps/details?id=br.mp.mpsc.qrtot&hl=pt_BR&gl=US">        
                <img src={qrIMG} alt="" className="overlayed-image"/>
              </a>
            }
          </div>            
        </div>
                      
      </ScrollToTop>      
  );
}

export default App;
